import React from 'react';
import Selection from 'components/Forms/utilities/Selection';

const InputRadio = props => {
  return <Selection {...props} type="radio" required />;
};

export default InputRadio;
